import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import './TopBar.css'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { Outlet } from 'react-router-dom'
import { ArrowLeft } from "lucide-react";


const Layout = () => {
  const navigate = useNavigate()

  const location = useLocation()
    const isHome = location.pathname === '/home';

  const hideBackOnHome = location.pathname === '/home';

  const isLoginPage = location.pathname === '/login' || location.pathname === '/'
  const [menuOpen, setMenuOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const toggleMenu = () => setMenuOpen(!menuOpen)

  const surveyorIcon = `${process.env.PUBLIC_URL}/custom-icons/surveyorIcon.png`
  const search_icon = `${process.env.PUBLIC_URL}/custom-icons/search_icon.png`
  const profile_pic = `${process.env.PUBLIC_URL}/custom-icons/profile_pic.png`
  const headphone = `${process.env.PUBLIC_URL}/custom-icons/headphone.png`

  // Icons
  const icons = {
    dashboard: {
      active: `${process.env.PUBLIC_URL}/custom-icons/dashboard-active.png`,
      inactive: `${process.env.PUBLIC_URL}/custom-icons/dashboard-inactive.png`
    },
    tickets: {
      active: `${process.env.PUBLIC_URL}/custom-icons/tickets-active.png`,
      inactive: `${process.env.PUBLIC_URL}/custom-icons/tickets-inactive.png`
    },
    claims: {
      active: `${process.env.PUBLIC_URL}/custom-icons/claims-active.png`,
      inactive: `${process.env.PUBLIC_URL}/custom-icons/claims-inactive.png`
    },
    discrepancies: {
      active: `${process.env.PUBLIC_URL}/custom-icons/discrepancies-active.png`,
      inactive: `${process.env.PUBLIC_URL}/custom-icons/discrepancies-inactive.png`
    }
  }

  // Helper to check if route is active
  const isActive = path => location.pathname === path
  // const insuranceUser = JSON.parse(localStorage.getItem('insuranceUser'))
  // const showHeader = Boolean(insuranceUser)

  // return (
  //   <>
  //     <nav className='navbar'>
  //       <div className='logo'>
  //         <LazyLoadImage
  //           src={surveyorIcon}
  //           alt="Surveyor's AI"
  //           className='surveyor-icon-home'
  //           effect='opacity'
  //         />
  //       </div>

  //       <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
  //         <button onClick={() => navigate('/home')}>Dashboard</button>
  //         <button onClick={() => navigate('/tickets')}>Tickets</button>
  //         <button onClick={() => navigate('/claims')}>Claims</button>
  //         <button onClick={() => navigate('/discrepancies')}>
  //           Discrepancies
  //         </button>

  //         <div className='search-container-wrapper'>
  //           <img
  //             src={headphone}
  //             alt='headphone icon'
  //             className='headphone-icon'
  //           />
  //           <div className='search-container'>
  //             <img
  //               src={search_icon}
  //               alt='search icon'
  //               className='search-icon'
  //             />
  //             <input type='text' placeholder='Search' className='search-box' />
  //           </div>
  //         </div>

  //         <img src={profile_pic} alt='User' className='profile-pic' />
  //       </div>

  //       <div className='hamburger' onClick={toggleMenu}>
  //         <div className='bar-menu'></div>
  //         <div className='bar-menu'></div>
  //         <div className='bar-menu'></div>
  //       </div>
  //     </nav>

  //     <div className='content'>
  //       {isMobile && (
  //         <div
  //           className='mobile-top-section'
  //           style={{ position: 'sticky', top: '2px', zIndex: 100000 }}
  //         >
  //           <div className='mobile-header'>
  //             <h2>
  //               <strong>Hello,</strong> John!
  //             </h2>
  //             <div className='mobile-icons'>
  //               <img
  //                 src={headphone}
  //                 alt='Support'
  //                 className='headphone-icon mobile-headphone'
  //               />
  //               <img
  //                 src={profile_pic}
  //                 alt='User'
  //                 className='profile-pic mobile-profile'
  //               />
  //             </div>
  //           </div>

  //           <div className='mobile-bottom-nav'>
  //             <div
  //               className={`nav-item ${isActive('/home') ? 'active-nav' : ''}`}
  //               onClick={() => navigate('/home')}
  //             >
  //               <img
  //                 src={
  //                   isActive('/home')
  //                     ? icons.dashboard.active
  //                     : icons.dashboard.inactive
  //                 }
  //                 alt='Dashboard'
  //               />
  //               <span>Dashboard</span>
  //             </div>
  //             <div
  //               className={`nav-item ${
  //                 isActive('/tickets') ? 'active-nav' : ''
  //               }`}
  //               onClick={() => navigate('/tickets')}
  //             >
  //               <img
  //                 src={
  //                   isActive('/tickets')
  //                     ? icons.tickets.active
  //                     : icons.tickets.inactive
  //                 }
  //                 alt='Tickets'
  //               />
  //               <span>Tickets</span>
  //             </div>
  //             <div
  //               className={`nav-item ${
  //                 isActive('/claims') ? 'active-nav' : ''
  //               }`}
  //               onClick={() => navigate('/claims')}
  //             >
  //               <img
  //                 src={
  //                   isActive('/claims')
  //                     ? icons.claims.active
  //                     : icons.claims.inactive
  //                 }
  //                 alt='Claims'
  //               />
  //               <span>Claims</span>
  //             </div>
  //             <div
  //               className={`nav-item ${
  //                 isActive('/discrepancies') ? 'active-nav' : ''
  //               }`}
  //               onClick={() => navigate('/discrepancies')}
  //             >
  //               <img
  //                 src={
  //                   isActive('/discrepancies')
  //                     ? icons.discrepancies.active
  //                     : icons.discrepancies.inactive
  //                 }
  //                 alt='Discrepancies'
  //               />
  //               <span>Discrepancies</span>
  //             </div>
  //           </div>
  //         </div>
  //       )}

  //       <Outlet />
  //     </div>
  //   </>
  // )
  
  // Add state for logout dropdown
  const [showLogoutDropdown, setShowLogoutDropdown] = useState(false)
  
  // Add logout function
  // const handleLogout = () => {
  //   // Clear user data
  //   localStorage.removeItem('insuranceUser')

     
  // setShowHeader(false)
  //   // Redirect to login page
  //   navigate('/')
  //   // Close dropdown
  //   setShowLogoutDropdown(false)
  // }
  const handleLogout = () => {
  // Clear user data
  localStorage.removeItem('insuranceUser')

  setShowHeader(false)
  
  // Dispatch custom event
  window.dispatchEvent(new Event('auth-change'))
  
  // Close dropdown
  setShowLogoutDropdown(false)
  
  navigate('/', { replace: true }) 
}
  
  // Add click outside handler for logout dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showLogoutDropdown && !event.target.closest('.profile-pic-container')) {
        setShowLogoutDropdown(false)
      }
    }
    
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [showLogoutDropdown])
  
  // Toggle logout dropdown
  const toggleLogoutDropdown = (e) => {
    e.stopPropagation()
    setShowLogoutDropdown(!showLogoutDropdown)
  }

  const [showHeader, setShowHeader] = useState(
  Boolean(localStorage.getItem("insuranceUser"))
);


useEffect(() => {
  const handleStorage = () =>
    setShowHeader(Boolean(localStorage.getItem("insuranceUser")));

  window.addEventListener("storage", handleStorage);
  return () => window.removeEventListener("storage", handleStorage);
}, []);

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);       // browser jaisa back
    } else {
      navigate('/home');  // fallback
    }
  }

  return (
    <>
      {showHeader && ( 
        <nav className='navbar'>
          <div className='logo'>
            <LazyLoadImage
              src={surveyorIcon}
              alt="Surveyor's AI"
              className='surveyor-icon-home'
              effect='opacity'
            />
          </div>

          <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
            <button onClick={() => navigate('/home')}>Dashboard</button>
            <button onClick={() => navigate('/tickets')}>Tickets</button>
            <button onClick={() => navigate('/claims')}>Claims</button>
            <button onClick={() => navigate('/discrepancies')}>
              Discrepancies
            </button>

            <div className='search-container-wrapper'>
              <img
                src={headphone}
                alt='headphone icon'
                className='headphone-icon'
              />
              <div className='search-container'>
                <img
                  src={search_icon}
                  alt='search icon'
                  className='search-icon'
                />
                <input
                  type='text'
                  placeholder='Search'
                  className='search-box'
                />
              </div>
            </div>

            {/* Profile picture with logout dropdown */}
            <div className="profile-pic-container" style={{ position: 'relative', display: 'inline-block' }}>
              <img 
                src={profile_pic} 
                alt='User' 
                className='profile-pic' 
                onClick={toggleLogoutDropdown}
                style={{ cursor: 'pointer' }}
              />
              
              {/* Logout Dropdown */}
              {showLogoutDropdown && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  right: 30,
                  marginTop: '5px',
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                  minWidth: '110px',
                  zIndex: 1000,
                  overflow: 'hidden'
                }}>
                  <div 
                    onClick={handleLogout}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '12px 16px',
                      cursor: 'pointer',
                      transition: 'background-color 0.2s',
                      color: '#333',
                      fontSize: '14px',
                      fontWeight: '500'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                  >
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="18" 
                      height="18" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                      style={{ color: '#ff4757' }}
                    >
                      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                      <polyline points="16 17 21 12 16 7"></polyline>
                      <line x1="21" y1="12" x2="9" y2="12"></line>
                    </svg>
                    <span>Logout</span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='hamburger' onClick={toggleMenu}>
            <div className='bar-menu'></div>
            <div className='bar-menu'></div>
            <div className='bar-menu'></div>
          </div>
        </nav>
      )}
            {showHeader && !hideBackOnHome &&(
        <button className="global-back-btn" onClick={handleBack}>
          <ArrowLeft size={22} />
        </button>
      )}


      <div className='content'>
        {showHeader && isMobile && isHome &&(
          <div
            className='mobile-top-section'
            style={{
              position: 'sticky',
              top: '2px',
              zIndex: 100000
            }}
          >
            <div className='mobile-header'>
              <h2>
                <strong>Hello,</strong> John!
              </h2>
              <div className='mobile-icons'>
                <img
                  src={headphone}
                  alt='Support'
                  className='headphone-icon mobile-headphone'
                />
                 <div className="profile-pic-container" style={{ position: 'relative', display: 'inline-block' }}>
            <img 
              src={profile_pic} 
              alt='User' 
              className='profile-pic mobile-profile' 
              onClick={toggleLogoutDropdown}
              style={{ cursor: 'pointer' }}
            />
            
            {/* Mobile Logout Dropdown - same as desktop */}
            {showLogoutDropdown && (
              <div style={{
                position: 'absolute',
                top: '100%',
                right: 30,
                marginTop: '5px',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                minWidth: '110px',
                zIndex: 1000,
                overflow: 'hidden'
              }}>
                <div 
                  onClick={handleLogout}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '12px 16px',
                    cursor: 'pointer',
                    transition: 'background-color 0.2s',
                    color: '#333',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                >
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="18" 
                    height="18" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    style={{ color: '#ff4757' }}
                  >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                  </svg>
                  <span>Logout</span>
                </div>
              </div>
            )}
          </div>
              </div>
            </div>

            <div className='mobile-bottom-nav'>
              <div
                className={`nav-item ${isActive('/home') ? 'active-nav' : ''}`}
                onClick={() => navigate('/home')}
              >
                <img
                  src={
                    isActive('/home')
                      ? icons.dashboard.active
                      : icons.dashboard.inactive
                  }
                  alt='Dashboard'
                />
                <span>Dashboard</span>
              </div>

              <div
                className={`nav-item ${
                  isActive('/tickets') ? 'active-nav' : ''
                }`}
                onClick={() => navigate('/tickets')}
              >
                <img
                  src={
                    isActive('/tickets')
                      ? icons.tickets.active
                      : icons.tickets.inactive
                  }
                  alt='Tickets'
                />
                <span>Tickets</span>
              </div>

              <div
                className={`nav-item ${
                  isActive('/claims') ? 'active-nav' : ''
                }`}
                onClick={() => navigate('/claims')}
              >
                <img
                  src={
                    isActive('/claims')
                      ? icons.claims.active
                      : icons.claims.inactive
                  }
                  alt='Claims'
                />
                <span>Claims</span>
              </div>

              <div
                className={`nav-item ${
                  isActive('/discrepancies') ? 'active-nav' : ''
                }`}
                onClick={() => navigate('/discrepancies')}
              >
                <img
                  src={
                    isActive('/discrepancies')
                      ? icons.discrepancies.active
                      : icons.discrepancies.inactive
                  }
                  alt='Discrepancies'
                />
                <span>Discrepancies</span>
              </div>
            </div>
          </div>
        )}

        <Outlet />
      </div>
    </>
  )
}

export default Layout